import React from "react";
import { ConfirmDialog } from "sprint-common-web";

interface RemoveFileRecordDetailsDialogProps {
    confirm(): void;
    onClose(): void;
    isOpen: boolean;
}

export const RemoveFileRecordDetailsDialog: React.VFC<RemoveFileRecordDetailsDialogProps> = ({
    confirm,
    onClose,
    isOpen
}: RemoveFileRecordDetailsDialogProps) => {
    return (
        <ConfirmDialog
            title="Remove file record"
            text="Are you sure you want to remove this file record? This action is irreversible."
            hidden={!isOpen}
            confirm={{ onClick: confirm }}
            cancel={{ onClick: onClose }}
        />
    );
};
